<div class="h-screen p-16 pt-40 lg:pt-56">
    <app-text [ngClass]="titleStyle" class="text-center text-4xl lg:text-7xl font-black" [value]="title"></app-text>
    <app-text class="pt-5 lg:pt-10 text-center text-xl lg:text-4xl font-black" [value]="message"></app-text>
    <div class="pt-3 lg:pt-5 flex justify-center w-full">
        <app-primary-button
                [value]="buttonLabel"
                (click)="goToUrl(router, buttonUrl)"></app-primary-button>
    </div>
</div>
<app-footer></app-footer>